(function () {
  'use strict';

  var moneyFormat = window.Shopify && window.Shopify.money_format ? window.Shopify.money_format : '${{amount}}';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount).replace('$', '$');
  }

  /* ---------------- Mobile menu ---------------- */
  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var isOpen = !mobileMenu.hidden;
      mobileMenu.hidden = isOpen;
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartToggle = document.querySelector('[data-cart-drawer-toggle]');
  var cartCloseEls = document.querySelectorAll('[data-cart-drawer-close]');
  var cartCountEls = document.querySelectorAll('[data-cart-count]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('data-open', '');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.removeAttribute('data-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartToggle) cartToggle.addEventListener('click', openCartDrawer);
  cartCloseEls.forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (el.tagName === 'A' && el.getAttribute('href') !== '#') return;
      e.preventDefault();
      closeCartDrawer();
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshCartDrawerSection() {
    return fetch('/?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('[data-cart-drawer]');
        if (newDrawer && cartDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
          bindCartDrawerEvents();
        }
      });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (res) { return res.json(); });
  }

  function addToCart(formData, triggerButton) {
    if (triggerButton) {
      triggerButton.disabled = true;
      triggerButton.classList.add('is-loading');
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshCartDrawerSection();
      })
      .then(function () {
        openCartDrawer();
      })
      .catch(function (err) {
        console.error('Vivantea: add to cart failed', err);
      })
      .finally(function () {
        if (triggerButton) {
          triggerButton.disabled = false;
          triggerButton.classList.remove('is-loading');
        }
      });
  }

  function changeCartLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshCartDrawerSection();
      });
  }

  function bindCartDrawerEvents() {
    var scope = cartDrawer || document;

    scope.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (el.tagName === 'A' && el.getAttribute('href') !== '#') return;
        e.preventDefault();
        closeCartDrawer();
      });
    });

    scope.querySelectorAll('[data-cart-item]').forEach(function (item) {
      var line = parseInt(item.getAttribute('data-line'), 10);
      var input = item.querySelector('[data-cart-quantity-input]');
      var decrease = item.querySelector('[data-cart-quantity-decrease]');
      var increase = item.querySelector('[data-cart-quantity-increase]');
      var remove = item.querySelector('[data-cart-remove]');

      if (decrease) {
        decrease.addEventListener('click', function () {
          var qty = Math.max(0, parseInt(input.value, 10) - 1);
          input.value = qty;
          changeCartLine(line, qty);
        });
      }
      if (increase) {
        increase.addEventListener('click', function () {
          var qty = parseInt(input.value, 10) + 1;
          input.value = qty;
          changeCartLine(line, qty);
        });
      }
      if (input) {
        input.addEventListener('change', function () {
          var qty = Math.max(0, parseInt(input.value, 10) || 0);
          changeCartLine(line, qty);
        });
      }
      if (remove) {
        remove.addEventListener('click', function () {
          changeCartLine(line, 0);
        });
      }
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ajax-cart-form]');
    if (!form) return;
    e.preventDefault();
    var formData = new FormData(form);
    var button = form.querySelector('[data-add-to-cart]');
    addToCart(formData, button);
  });

  bindCartDrawerEvents();

  /* ---------------- Product page ---------------- */
  var productForm = document.querySelector('#ProductForm');
  if (productForm) {
    var variantsScript = document.getElementById('ProductVariantsJson');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var variantInput = productForm.querySelector('[data-variant-id-input]');
    var priceEl = document.getElementById('ProductPrice');
    var addButton = productForm.querySelector('[data-add-to-cart]');
    var addButtonText = productForm.querySelector('[data-add-to-cart-text]');
    var mainImage = document.getElementById('ProductMainImage');

    var selectedOptions = {};
    productForm.querySelectorAll('.option-swatch.is-selected').forEach(function (btn) {
      selectedOptions[btn.getAttribute('data-option-index')] = btn.getAttribute('data-option-value');
    });

    function findMatchingVariant() {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return Object.keys(selectedOptions).every(function (idx) {
          return opts[parseInt(idx, 10)] === selectedOptions[idx];
        });
      });
    }

    function updateForVariant(variant) {
      if (!variant) return;
      variantInput.value = variant.id;
      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            '<span class="price--compare">' + formatMoney(variant.compare_at_price) + '</span>' +
            '<span class="price--sale">' + formatMoney(variant.price) + '</span>';
        } else {
          priceEl.innerHTML = '<span>' + formatMoney(variant.price) + '</span>';
        }
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        if (addButtonText) addButtonText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (mainImage && variant.featured_image && variant.featured_image.src) {
        mainImage.src = variant.featured_image.src;
      }
    }

    productForm.querySelectorAll('.option-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = btn.getAttribute('data-option-index');
        var group = productForm.querySelectorAll('.option-swatch[data-option-index="' + index + '"]');
        group.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        selectedOptions[index] = btn.getAttribute('data-option-value');
        var match = findMatchingVariant();
        if (match) updateForVariant(match);
      });
    });

    var qtyInput = productForm.querySelector('#ProductQuantity');
    var qtyDecrease = productForm.querySelector('[data-quantity-decrease]');
    var qtyIncrease = productForm.querySelector('[data-quantity-increase]');
    if (qtyDecrease && qtyInput) {
      qtyDecrease.addEventListener('click', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
      });
    }
    if (qtyIncrease && qtyInput) {
      qtyIncrease.addEventListener('click', function () {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      });
    }

    var thumbnails = document.querySelectorAll('[data-product-thumbnail]');
    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbnails.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImage) mainImage.src = thumb.getAttribute('data-image-url');
      });
    });
  }
})();
